export const validateField = (name, value) => {
  switch (name) {
    case "name":
      if (!value.trim()) return "Ingresa tu nombre completo";
      if (value.trim().length < 3) {
        return "El nombre debe tener mínimo 3 caracteres";
      }
      return "";

    case "phone":
      if (!value.trim()) return "Ingresa tu teléfono";

      if (!/^[0-9+\-\s()]{7,20}$/.test(value)) {
        return "Ingresa un teléfono válido";
      }

      return "";

    case "email":
      if (!value.trim()) return "Ingresa tu correo electrónico";

      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        return "Ingresa un correo válido";
      }

      return "";

    case "type":
      if (!value) return "Selecciona un tipo de solicitud";
      return "";

    case "message":
      if (!value.trim()) return "Describe tu solicitud";

      if (value.trim().length < 10) {
        return "La descripción debe tener mínimo 10 caracteres";
      }

      return "";

    default:
      return "";
  }
};

export const validateForm = (formData) => {
  const errors = {};

  Object.keys(formData).forEach((key) => {
    if (key === "file") return;

    const error = validateField(key, formData[key]);

    if (error) {
      errors[key] = error;
    }
  });

  return errors;
};